/* eslint-disable ember/classic-decorator-hooks, ember/no-computed-properties-in-native-classes */
import { computed } from '@ember/object';

import FirstOrderCommonCircuit from '../common/circuit';
import ActualFilterAmplitude from './actual-filter-amplitude';
import NoiseGroup from './noise-group';
import IdealOpAmp from './ideal-op-amp';
import LowPassFirstOrderCircuit from './circuit';
import { isNearInfinity } from '../../../../utils/common';

// First-order lowpass. This inherits for first-order common. Most of the logic for creating
// the circuit components are in the base class.
export default class FirstOrderLowPassCircuit extends FirstOrderCommonCircuit {
  supportedComponents;
  actualFilterAmplitudeModel;
  noiseGroupModel;
  idealOpAmpModel;
  circuitModel;
  idealOpAmpValuePaths; //components where the ideal-op-amp is dependent on. See the ideal op amp as to which components it's using for this configuration.
  init() {
    super.init();
    this.actualFilterAmplitudeModel = ActualFilterAmplitude;
    this.noiseGroupModel = NoiseGroup;
    this.idealOpAmpModel = IdealOpAmp;
    this.circuitModel = LowPassFirstOrderCircuit;
    this.supportedComponents = ['c1', 'r1', 'r3', 'r4'];
    this.idealOpAmpValuePaths = ['r1', 'r3', 'r4'];
  }

  @computed('idealValues.r3IdealValue') get needReferenceStage() {
    var result = isNearInfinity(this.idealValues.r3IdealValue);
    return !result;
  }
}
